import {DuckDBQueryBuilder} from '@/agUtils/sql/QueryBuilder'
import {IServerSideGetRowsRequest} from 'ag-grid-community'

export function queryFromAggrid(tableName: string, request: IServerSideGetRowsRequest): string {
    const builder = new DuckDBQueryBuilder(tableName)
    return builder.buildQuery(request)
}